import { useState } from "react";
import { Link } from "react-router-dom";
import { DropdownToggle, DropdownMenu, Dropdown } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";

import UserAvatar from "../../../components/UserAvatar/UserAvatar";
import Icon from "../../../components/Icon/Icon";
import Currency, { ConvertCurrency } from "../../Currency/Currency";
import { LinkItem, LinkList } from "../../../components/Links/Links";
import { convertRoleToPath, convertRoleToText } from "../../../utils";
import { setThemeAction } from "./../../../redux/actions/themeActions/themeActions";

const UserHeader = () => {
  const auth = useSelector((state) => state.auth);
  const user = useSelector((state) => state.user);

  const [open, setOpen] = useState(false);

  const toggle = () => setOpen((prevState) => !prevState);

  return (
    <Dropdown isOpen={open} className="user-dropdown" toggle={toggle}>
      <DropdownToggle
        tag="a"
        href="#toggle"
        className="dropdown-toggle"
        onClick={(ev) => {
          ev.preventDefault();
        }}
      >
        <div className="user-toggle">
          <UserAvatar icon="user-alt" className="sm" />
          <div className="user-info d-none d-md-block">
            <div className="user-status">{convertRoleToText(auth?.role)}</div>
            <div className="user-name dropdown-indicator-2">
              {user?.firstName} {user?.lastName}
            </div>
          </div>
        </div>
      </DropdownToggle>
      <DropdownMenu right className="dropdown-menu-md dropdown-menu-s1">
        <UserHeaderContent toggle={toggle} />
      </DropdownMenu>
    </Dropdown>
  );
};

export default UserHeader;

export const UserHeaderContent = ({ toggle }) => {
  const dispatch = useDispatch();

  const auth = useSelector((state) => state.auth);
  const user = useSelector((state) => state.user);
  const theme = useSelector((state) => state.theme);

  return (
    <>
      <div className="dropdown-inner user-card-wrap bg-lighter d-none d-md-block">
        <div className="user-card sm">
          <UserAvatar
            {...(user?.avatar
              ? { image: user?.avatar }
              : {
                  icon: "user-alt",
                })}
          />
          <div className="user-info">
            <span className="lead-text">
              {user?.firstName} {user?.lastName}
            </span>
            <span className="sub-text">{user?.phoneNumber}</span>
          </div>
        </div>
      </div>
      <div className="dropdown-inner">
        <LinkList>
          {!auth.isAdmin && (
            <LinkItem
              link={`/${convertRoleToPath(auth?.role)}/transactions`}
              icon="wallet"
              onClick={toggle}
            >
              <ConvertCurrency price={user.wallet} /> <Currency />
            </LinkItem>
          )}
          <LinkItem
            link={`/${convertRoleToPath(auth?.role)}/profile`}
            icon="user-alt"
            onClick={toggle}
          >
            حساب کاربری
          </LinkItem>
          <LinkItem tag="a" link="#" icon="moon">
            <div className="custom-control custom-switch is-right">
              <input
                type="checkbox"
                className="custom-control-input"
                checked={theme.isDarkMode}
                onChange={(e) =>
                  dispatch(
                    setThemeAction({
                      skin: e.target.checked ? "dark" : "light",
                    })
                  )
                }
                id="changeTheme"
              />
              <label className="custom-control-label" htmlFor="changeTheme">
                حالت شب
              </label>
            </div>
          </LinkItem>
        </LinkList>
      </div>
      <div className="dropdown-inner">
        <LinkList>
          <Link to="/auth/logout" className="text-danger">
            <Icon name="signout" />
            <span>خروج از حساب کاربری</span>
          </Link>
        </LinkList>
      </div>
    </>
  );
};
